import React, { useState, useEffect } from 'react';

const ErrorAlert = ({ message, onClose }) => {
    const [isVisible, setIsVisible] = useState(true);

    useEffect(() => {
        const timer = setTimeout(() => {
            setIsVisible(false);
            onClose?.();
        }, 5000);

        return () => clearTimeout(timer);
    }, [onClose]);

    if (!isVisible) return null;

    return (
        <>
            {/* Yarı saydam arka plan overlay */}
            <div className="fixed inset-0 bg-gray-600 bg-opacity-50 backdrop-blur-sm z-40" />

            {/* Alert container */}
            <div className="fixed top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 z-50
                        bg-white border-t-4 border-red-500 p-8 min-w-[500px] max-w-2xl w-full
                        shadow-2xl rounded-lg flex flex-col items-center">
                <div className="flex flex-col items-center w-full mb-4">
                    <div className="text-red-500 mb-4">
                        <svg className="w-12 h-12" fill="currentColor" viewBox="0 0 20 20">
                            <path fillRule="evenodd"
                                  d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7 4a1 1 0 11-2 0 1 1 0 012 0zm-1-9a1 1 0 00-1 1v4a1 1 0 102 0V6a1 1 0 00-1-1z"
                                  clipRule="evenodd" />
                        </svg>
                    </div>
                    <p className="text-gray-700 text-lg font-medium text-center px-4">{message}</p>
                </div>
                <button
                    onClick={() => {
                        setIsVisible(false);
                        onClose?.();
                    }}
                    className="absolute top-3 right-3 text-gray-400 hover:text-gray-600
                               transition-colors duration-200 p-1 rounded-full
                               hover:bg-gray-100"
                >
                    <svg className="w-6 h-6" fill="currentColor" viewBox="0 0 20 20">
                        <path fillRule="evenodd"
                              d="M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z"
                              clipRule="evenodd" />
                    </svg>
                </button>
            </div>
        </>
    );
};

export default ErrorAlert;